import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  $('body').on('click', '.project-layout-selector a', function(e){
    e.preventDefault();

    let $view = $(this).parents('.views-element-container:first');

    if($(this).hasClass('project-layout-selector--grid')){
        $view.removeClass('project-layout-selector--list');
    }else{
        $view.addClass('project-layout-selector--list');
    }

  });

  if($('#project-tabs').length > 0){
    let activeTab = location.hash.substr(1);

    if(activeTab){
      $('#project-tabs li[data-id="'+activeTab+ '"] a').addClass('active');
    }

  }

})(jQuery, Drupal, drupalSettings);
